import moment from 'moment';
import React from 'react';
// Hall Ticket, Zoom link and Confirmation
const SeventhStepWhatsappTemplate = ({ values }) => {
  const {
    conference_short_name,
    client_name,
    venue_name,
    full_address,
    map_link,
    zoom_link,
    download_zoom,
    registration_date_time,
    hall_ticket_link,
    support_email,
    support_phone,
  } = values;

  return (
    <div>
      <p>{client_name ? `Dear ${client_name},` : `Dear [Name],,`}</p>

      <p>
        We’re pleased to share the final agenda and important details for your
        participation in{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : '[Conference Short Name]'}
        </strong>
        .
      </p>

      <p>
        📍
        <strong>Venue Address:</strong>{' '}
        {venue_name ? venue_name : '[Venue Name]'},{' '}
        {full_address ? full_address : `[Full Address]`}
        <br />
        📌
        <strong>Google Maps:</strong>{' '}
        {map_link ? <a href={map_link}>{map_link}</a> : '[Google Maps Link]'}
      </p>

      <p>
        <strong>💻 For Virtual Participants:</strong>
        <br />
        Access the sessions via Zoom:{' '}
        {zoom_link ? <a href={zoom_link}>{zoom_link}</a> : '[Access Zoom Link]'}
        <br />
        🎥 Official Zoom background:{' '}
        {download_zoom ? (
          <a href={download_zoom}>{download_zoom}</a>
        ) : (
          '[Download Zoom Background]'
        )}
      </p>

      <h6>
        <strong>📝 On-Site Registration:</strong>
      </h6>
      <p>
        Location: Registration Desk,{' '}
        {full_address ? full_address : '[Full Address]'}
      </p>

      <p>
        Date and Time:{' '}
        {registration_date_time
          ? moment(registration_date_time).format('YYYY-MM-DD [and] HH:mm')
          : '[Date and Time Range for Registration]'}
      </p>

      <p>
        <strong>🎟️ Access Hall Ticket/Zoom Link:</strong>{' '}
        {hall_ticket_link ? (
          <a href={hall_ticket_link}>{hall_ticket_link}</a>
        ) : (
          '[Access Link]'
        )}
      </p>

      <p>
        <strong>📌 Please Bring:</strong>
        <ul>
          <li>Valid ID</li>
          <li>Registration confirmation</li>
          <li>Presentation materials (if applicable)</li>
        </ul>
      </p>

      <p>
        Should you have any questions or need assistance, feel free to reach us
        at {support_email ? support_email : '[Support Email]'} or{' '}
        {support_phone ? support_phone : '[Support Phone Number]'}.
      </p>
      <p>We look forward to your active participation.</p>
    </div>
  );
};

export default SeventhStepWhatsappTemplate;
